export class RAlternateCertificate {
    public body: string;
    public private: string;
    public chain: string;
}
